/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT USER PAGE
 -----------------------------------------*/
import('cookie');

let PrimaryRoleSelector = {
    primaryRoleSelector: $('#primary-role'),
    removeOption: (option) => {
        option.remove();
    },
    addOption: (option) => {
        PrimaryRoleSelector.primaryRoleSelector.append(option);
    },
    init: () => {
        $(document).on('change', '.role-checker', function () {
            let id = $(this).val();
            if (this.checked) {
                let title = $('label[for="roles-' + id + '"]').html();
                PrimaryRoleSelector.addOption('<option value="' + id + '">' + title + '</option>');
            } else {
                let option = PrimaryRoleSelector.primaryRoleSelector.find('option[value="' + id + '"]');
                if (option) {
                    PrimaryRoleSelector.removeOption(option);
                }
            }
        });
    }
};

export default PrimaryRoleSelector;
